import { Injectable, EventEmitter } from '@angular/core';
import { CostCenterModel } from '../../models/referential/cost-center.model';

@Injectable()
export class CostCenterEventsService {

  public testEmitEvent: EventEmitter<CostCenterModel> = new EventEmitter<CostCenterModel>();

  constructor() {
  }

  public emitTestCenter(costCenterModel: CostCenterModel) {
    this.testEmitEvent.emit(costCenterModel);
  }

}
